export const TimePeriodSelector = ({ selectedPeriod, onPeriodChange }) => {
  const periods = [
    { value: 'DAY', label: 'Day' },
    { value: 'WEEK', label: 'Week' },
  ];

  return (
    <div className="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-1 gap-1">
      {periods.map((period) => (
        <button
          key={period.value}
          onClick={() => onPeriodChange(period.value)}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-150 ${
            selectedPeriod === period.value
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
};
